import {
  Box,
  Skeleton,
  SkeletonProps,
  StackProps,
  VStack
} from '@chakra-ui/react';
import React from 'react';

export interface TileLoaderProps extends StackProps {
  titleLoader?: boolean; // set to true to show title loader
  descriptionLoader?: boolean; // set to true to show description loader
  authorLoader?: boolean; // set to true to show author loader
  ratingLoader?: boolean; // set to true to show rating loader,
  imageSkeletonProps?: SkeletonProps;
  imageSkeletonContainerProps?: SkeletonProps;
}

const TileLoader = ({
  titleLoader,
  descriptionLoader,
  authorLoader,
  ratingLoader,
  imageSkeletonProps = {},
  imageSkeletonContainerProps = {},
  ...containerProps
}: TileLoaderProps) => {
  return (
    <VStack
      width="100%"
      spacing="10px"
      alignItems="flex-start"
      {...containerProps}
    >
      <Box width="100%" position="relative" {...imageSkeletonContainerProps}>
        <Skeleton
          width="100%"
          height="200px"
          borderRadius="10px"
          {...imageSkeletonProps}
        />
      </Box>
      {ratingLoader && (
        <Skeleton width="30%" height="20px" borderRadius="10px" />
      )}
      {titleLoader && (
        <Skeleton width="50%" height="20px" borderRadius="10px" />
      )}
      {authorLoader && (
        <Skeleton width="30%" height="20px" borderRadius="10px" />
      )}
      {descriptionLoader && (
        <Skeleton width="100%" height="30px" borderRadius="10px" />
      )}
    </VStack>
  );
};

export default TileLoader;
